import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  PublicRoomSystem,
  UpdateRoomSystemAsAdminDto,
  UpdateRoomSystemDto,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateRoomSystemAsAdmin = async ({
  id,
  organisationId,
  roomSystem,
}: {
  id: string;
  organisationId: string;
  roomSystem: UpdateRoomSystemDto;
}): Promise<PublicRoomSystem> => {
  const response = await axiosClient.patch(
    `${organisationId}/room-systems/${id}/admin`,
    roomSystem,
  );
  return response.data;
};

function useUpdateRoomSystemAsAdmin(
  mutationOptions?: UseMutationOptions<
    PublicRoomSystem,
    HttpError,
    {
      id: string;
      organisationId: string;
      roomSystem: UpdateRoomSystemAsAdminDto;
    }
  >,
) {
  return useMutation({
    mutationFn: updateRoomSystemAsAdmin,
    ...mutationOptions,
  });
}

export { useUpdateRoomSystemAsAdmin };
